function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#cda1a7",
  d: "M59 55H5a2 2 0 01-2-2V39h19.31L26 43h12.44L42 39h19v14a2 2 0 01-2 2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#deb4ba",
  d: "M4 42h21.08l-1.84-2H4a1 1 0 000 2zm56-2H41.11l-1.78 2H60a1 1 0 000-2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#acb7d0",
  d: "M61 39H42l-5 4H27l-4.69-4H3l8-32h42l8 32z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M61.83 36.24l-7.47-28A3 3 0 0051.46 6H12.54a3 3 0 00-2.9 2.23l-7.47 28A5 5 0 002 37.52V53a3 3 0 003 3h54a3 3 0 003-3V37.52a5 5 0 00-.17-1.28zm-57.73.51l7.47-28a1 1 0 011-.74h38.89a1 1 0 011 .74l7.47 28a3 3 0 01.1.77V38h-17.2a3 3 0 00-2.12.88l-2.83 2.83a1 1 0 01-.71.29H26.83a1 1 0 01-.71-.29l-2.83-2.83a3 3 0 00-2.12-.88H4v-.48a3 3 0 01.1-.77zM59 54H5a1 1 0 01-1-1V40h17.17a1 1 0 01.71.29l2.83 2.83a3 3 0 002.12.88h10.34a3 3 0 002.12-.88l2.83-2.83a1 1 0 01.71-.29H60v13a1 1 0 01-1 1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M7 46a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#faefde",
  d: "M19 16h26a1 1 0 000-2H19a1 1 0 000 2zm-2 8h30a1 1 0 000-2H17a1 1 0 000 2zm-2 8h34a1 1 0 000-2H15a1 1 0 000 2z"
});

function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgEmpty;